import { ClipLoader } from "react-spinners";

export const Loader = ({ loading }) => {
  return (
    loading && (
      <div className="flex justify-center items-center h-screen">
        <ClipLoader size={50} color={"red"} loading={loading} />
      </div>
    )
  );
};
